// Mascara, validacao e normalizacao de telefone BR (PT-BR)
// Armazenamento canonico: DDI+DDD+numero (ex.: 5511999999999). Mascara e apenas visual.
export const PHONE_INVALID_MSG = "Telefone inválido. Verifique o DDD e o número.";

// DDDs oficiais validos no Brasil
const VALID_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19,
  21, 22, 24, 27, 28,
  31, 32, 33, 34, 35, 37, 38,
  41, 42, 43, 44, 45, 46, 47, 48, 49,
  51, 53, 54, 55,
  61, 62, 63, 64, 65, 66, 67, 68, 69,
  71, 73, 74, 75, 77, 79,
  81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

// Retorna apenas DDD+numero (10 ou 11 digitos), removendo o DDI 55 se houver
function national(value) {
  let d = (value || "").replace(/\D/g, "");
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) d = d.slice(2);
  return d.slice(0, 11);
}

// Mascara (11) 99999-9999 (celular) ou (11) 9999-9999 (fixo)
export function maskPhone(value) {
  const d = national(value);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// Valida DDD, quantidade de digitos e regras de celular/fixo
export function isValidPhone(value) {
  const d = national(value);
  if (d.length !== 10 && d.length !== 11) return false;
  if (!VALID_DDDS.has(parseInt(d.slice(0, 2), 10))) return false;
  if (d.length === 11 && d[2] !== "9") return false;
  if (d.length === 10 && (d[2] === "0" || d[2] === "1")) return false;
  if (new Set(d.split("")).size === 1) return false;
  return true;
}

// Retorna o telefone canonico (DDI+DDD+numero), ex.: '5511999999999'
export function normalizePhone(value) {
  const d = national(value);
  if (d.length === 10 || d.length === 11) return "55" + d;
  return (value || "").replace(/\D/g, "");
}
